import React from 'react';
import {
  ScrollView,
  View,
  Text,
  TouchableOpacity,
  StyleSheet
} from 'react-native';
import { StatusBar } from 'expo-status-bar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NavBar from '../components/NavBar';

export default function AboutScreen({ navigation }) {
  return (
    <View style={styles.outerContainer}>
      <Header navigation={navigation} />
      <ScrollView contentContainerStyle={styles.container}>
        <StatusBar style="light" />

      {/* Header */}
      <Text style={styles.headline}>About CritCash</Text>
      <Text style={styles.tagline}>Go live. The rest is built in.</Text>

      {/* The Problem / Why we exist */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Why We Exist</Text>
        <Text style={styles.bodyText}>
          Every streamer starts with an empty room.
          Going live is the easy part; growing a crowd
          and keeping it coming back is the hard part,
          and most platforms leave that to you.
        </Text>
        <Text style={styles.bodyText}>
          CritCash has those tools built in. Save every
          stream as a video, stream with your squad on one page,
          and run your own events and leagues for the people
          who watch you, all from home.
        </Text>
      </View>

      {/* What we do — the three pillars */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>What CritCash Is</Text>

        <View style={styles.featureItem}>
          <Text style={styles.featureTitle}>Go Live on Any Game</Text>
          <Text style={styles.featureText}>
            One stream key works for every game you play.
            Your viewers watch free with no account, and every
            stream saves as a video.
          </Text>
        </View>

        <View style={styles.featureItem}>
          <Text style={styles.featureTitle}>Tools That Grow Your Crowd</Text>
          <Text style={styles.featureText}>
            Followers get a notification when you go live and can see your weekly
            schedule. Live chat and squad streams, with your whole crew on one page,
            keep them in the room.
          </Text>
        </View>

        <View style={styles.featureItem}>
          <Text style={styles.featureTitle}>Run Your Own Events</Text>
          <Text style={styles.featureText}>
            Competition is one of the tools: run head-to-heads,
            brackets and leagues for your community, free to enter
            and played on stream.
          </Text>
        </View>
      </View>

      {/* How It Works */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>How It Works</Text>

        <View style={styles.stepContainer}>
          <Text style={styles.stepNumber}>1</Text>
          <View style={styles.stepContent}>
            <Text style={styles.stepTitle}>Sign Up Free</Text>
            <Text style={styles.stepText}>Create your account. No card needed: going live is free.</Text>
          </View>
        </View>

        <View style={styles.stepContainer}>
          <Text style={styles.stepNumber}>2</Text>
          <View style={styles.stepContent}>
            <Text style={styles.stepTitle}>Go Live</Text>
            <Text style={styles.stepText}>Download CritCast for Windows to sign in and go live (it sets up OBS for you), or drop your stream key into OBS or Streamlabs. Viewers watch free, no account needed.</Text>
          </View>
        </View>

        <View style={styles.stepContainer}>
          <Text style={styles.stepNumber}>3</Text>
          <View style={styles.stepContent}>
            <Text style={styles.stepTitle}>Grow Your Crowd</Text>
            <Text style={styles.stepText}>Post your weekly schedule, stream with your squad, and save every stream as a video.</Text>
          </View>
        </View>

        <View style={styles.stepContainer}>
          <Text style={styles.stepNumber}>4</Text>
          <View style={styles.stepContent}>
            <Text style={styles.stepTitle}>Host Your First Event</Text>
            <Text style={styles.stepText}>Set up a head-to-head, a bracket or a league, play it on stream, and your results go on your record.</Text>
          </View>
        </View>
      </View>

      {/* What makes it different */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>What's Built In</Text>

        <View style={styles.featureItem}>
          <Text style={styles.featureTitle}>Verified Results</Text>
          <Text style={styles.featureText}>On supported games, results are verified straight from your stream. On other games, players report the result and our team reviews any dispute. Some formats, such as battle royale, are scored by our team.</Text>
        </View>

        <View style={styles.featureItem}>
          <Text style={styles.featureTitle}>Free to Start</Text>
          <Text style={styles.featureText}>Go live on a free account, no card required. Every event is free to enter.</Text>
        </View>

        <View style={styles.featureItem}>
          <Text style={styles.featureTitle}>Run It Your Way</Text>
          <Text style={styles.featureText}>Create your own events and leagues: your rules, your schedule, your community.</Text>
        </View>

        <View style={styles.featureItem}>
          <Text style={styles.featureTitle}>Built-in Streaming</Text>
          <Text style={styles.featureText}>Download CritCast for Windows or connect one stream key to go live on any game. Every stream saves as a video, and your squad can stream together on one page.</Text>
        </View>
      </View>

      {/* Games on CritCash */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Games on CritCash</Text>

        <View style={styles.gameCategory}>
          <Text style={styles.categoryTitle}>Now Live</Text>
          <Text style={styles.gameList}>Gran Turismo 7 • Madden • Call of Duty • Marvel Rivals</Text>
        </View>

        <View style={styles.gameCategory}>
          <Text style={styles.categoryTitle}>Coming Soon</Text>
          <Text style={styles.gameList}>Dota 2 • Counter-Strike 2 • Street Fighter 6 • Tekken 8 • Mortal Kombat 1 • Valorant • Rainbow Six Siege • Overwatch 2 • NBA 2K • Rocket League • League of Legends</Text>
        </View>
      </View>

      {/* For Developers */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>For Game Developers</Text>
        <Text style={styles.bodyText}>
          Game studios can submit titles to feature on CritCash and reach the
          players who stream them and the viewers who watch. Interested? Reach us at developers@critcash.com.
        </Text>
      </View>

      {/* Legal & Eligibility */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Legal & Eligibility</Text>
        <Text style={styles.bodyText}>
          CritCash is a streaming platform for gamers. Its events, leagues, and
          tournaments are decided by player skill, never chance. You never pay
          to participate: entry to every event is free. Results and placements
          are never paid.
        </Text>
        <Text style={styles.bodyText}>
          Free to start. You must be 18 or older to create an account — CritCash
          is an adults-only platform, open worldwide. Prices are shown in USD.
        </Text>
        <Text style={styles.disclaimerText}>
          CritCash is not affiliated with or sponsored by any game publisher
          unless explicitly stated. See our{' '}
          <Text
            style={{ color: '#FCD000', textDecorationLine: 'underline' }}
            onPress={() => navigation.navigate('Legal')}
          >
            Legal &amp; Eligibility page
          </Text>{' '}
          for full details.
        </Text>
      </View>

      {/* Company Info */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>The Company</Text>
        <Text style={styles.bodyText}>
          CritCash, Inc. is a Delaware corporation headquartered in Madison,
          Wisconsin. It runs CritCash, the streaming platform for gamers, with the
          tools to grow an audience built in.
        </Text>
      </View>

      {/* Contact */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Contact</Text>
        <Text style={styles.contactItem}>General: support@critcash.com</Text>
        <Text style={styles.contactItem}>Developers: developers@critcash.com</Text>
        <Text style={styles.contactItem}>Press: press@critcash.com</Text>
        <Text style={styles.contactItem}>Website: critcash.com</Text>
      </View>

      {/* Navigation Button */}
      <TouchableOpacity
        style={styles.button}
        onPress={() => navigation.navigate('Lobby')}
      >
        <Text style={styles.buttonText}>Return to Lobby</Text>
      </TouchableOpacity>

      </ScrollView>
      <Footer navigation={navigation} />
      <NavBar navigation={navigation} />
    </View>
  );
}

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    backgroundColor: '#000',
  },
  container: {
    flexGrow: 1,
    backgroundColor: '#000',
    alignItems: 'center',
    padding: 16,
    paddingBottom: 32
  },
  headline: {
    color: '#FCD000',
    fontSize: 28,
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: 16,
    marginBottom: 8
  },
  tagline: {
    color: '#999',
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 32,
    fontStyle: 'italic'
  },
  section: {
    width: '100%',
    maxWidth: 600,
    marginBottom: 32,
    paddingHorizontal: 8
  },
  sectionTitle: {
    color: '#FCD000',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#333',
    paddingBottom: 8
  },
  bodyText: {
    color: '#CCC',
    fontSize: 15,
    lineHeight: 24,
    marginBottom: 12
  },
  disclaimerText: {
    color: '#888',
    fontSize: 13,
    lineHeight: 20,
    fontStyle: 'italic',
    marginTop: 8
  },
  bold: {
    fontWeight: 'bold',
    color: '#FFF'
  },

  // Steps
  stepContainer: {
    flexDirection: 'row',
    marginBottom: 20,
    alignItems: 'flex-start'
  },
  stepNumber: {
    color: '#000',
    backgroundColor: '#FCD000',
    width: 28,
    height: 28,
    borderRadius: 14,
    textAlign: 'center',
    lineHeight: 28,
    fontWeight: 'bold',
    fontSize: 16,
    marginRight: 12
  },
  stepContent: {
    flex: 1
  },
  stepTitle: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4
  },
  stepText: {
    color: '#AAA',
    fontSize: 14,
    lineHeight: 20
  },

  // Games
  gameCategory: {
    marginBottom: 16
  },
  categoryTitle: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4
  },
  gameList: {
    color: '#AAA',
    fontSize: 14,
    lineHeight: 20
  },

  // Features
  featureItem: {
    marginBottom: 16
  },
  featureTitle: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4
  },
  featureText: {
    color: '#AAA',
    fontSize: 14,
    lineHeight: 20
  },

  // Contact
  contactItem: {
    color: '#CCC',
    fontSize: 15,
    lineHeight: 28
  },

  // Button
  button: {
    backgroundColor: '#FCD000',
    paddingVertical: 14,
    paddingHorizontal: 32,
    borderRadius: 8,
    marginTop: 16,
    marginBottom: 24
  },
  buttonText: {
    color: '#000',
    fontWeight: 'bold',
    fontSize: 16
  }
});
